import styled from "styled-components";

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
`;

export const Text = styled.p`
  color: #212427;
  text-align: center;
  font-size: 16px;
  margin: 0;
  font-weight: 400;
  line-height: 24px;
`;
